import { RouteObject } from 'react-router-dom';
import { VisitType } from '@csp/csp-common-model';
import React from 'react';
import { PathUtil } from '../util/PathUtil';
import { CspPath } from '../../../CspPath';

const lazyLoadPages: () => Promise<typeof import('./VisitPages')> = () =>
  import(/* webpackPrefetch: true */ './VisitPages');

const PatientVisitsListPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.PatientVisitsListPage,
  })),
);

const PatientVisitDetailsNavPage = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.PatientVisitDetailsNavPage,
  })),
);

const LoadAndViewUnbookedVisit = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.LoadAndViewUnbookedVisit,
  })),
);

const LoadAndViewBookedVisit = React.lazy(() =>
  lazyLoadPages().then(mod => ({
    default: mod.LoadAndViewBookedVisit,
  })),
);

export const VisitRoutes: RouteObject[] = [
  // Visit List
  {
    index: true,
    element: <PatientVisitsListPage />,
  },
  {
    element: <PatientVisitDetailsNavPage />,
    children: [
      // Visit Details
      {
        path: PathUtil.toRelativePath(CspPath.PATIENT_VISITS, CspPath.PATIENT_VISIT_DETAILS, true),
        element: <LoadAndViewBookedVisit />,
      },
      // Unbooked Scheduled Visit
      {
        path: PathUtil.toRelativePath(CspPath.PATIENT_VISITS, CspPath.PATIENT_VISIT_DETAILS_UNBOOKED_SCHEDULED, true),
        element: <LoadAndViewUnbookedVisit visitType={VisitType.SCHEDULED} />,
      },
    ],
  },
];
